import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, map, Observable } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class WavesNodeConnectorService {
  constructor(private _httpClient: HttpClient) {}

  private _apiUrl = environment.nodeUrl;

  public getAssetBalanceByAddress$(
    address: string,
    assetId: string,
  ): Observable<number> {
    if (!address || !assetId) return EMPTY;
    return this._httpClient
      .get<{
        address: string;
        assetId: string;
        balance: number;
      }>(`${this._apiUrl}/assets/balance/${address}/${assetId}`)
      .pipe(
        map<{ address: string; assetId: string; balance: number }, number>(
          (data) => data.balance,
        ),
      );
  }

  public getStakedAmountByAddress$(
    dAppAddress: string,
    address: string,
  ): Observable<number> {
    if (!address || !dAppAddress) return EMPTY;
    return this._httpClient
      .post<
        Required<{
          result: Required<{
            value: Required<{ [key: string]: Required<{ value: number }> }>;
          }>;
        }>
      >(
        `${this._apiUrl}/utils/script/evaluate/${dAppAddress}`,
        JSON.stringify({ expr: `getStakedAmount(false, "${address}")` }),
        { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } },
      )
      .pipe(
        map((data) => {
          return data.result.value['_2'].value;
        }),
      );
  }
}
